// React i hooks
import { memo } from "react";

// Tipovi i konstante
import { FleetSettingDetailCardProps } from "./types";

// UI komponente
import VehicleCategoryCard from "./components/VehicleCategoryCard/VehicleCategoryCard";
import EcoFeeCard from "./components/EcoFeeCard/EcoFeeCard";


const FleetSettingDetailCard: React.FC<FleetSettingDetailCardProps> = () => {

  return (
    <div className="">
      <VehicleCategoryCard />
      <EcoFeeCard />
    </div>
  );
};
export default memo(FleetSettingDetailCard);
